import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-03/lesson-01/task-01";

const task: Slide = {
  title: "Here is a selection of methods/items. Put them in the right category.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
